"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleRequests = void 0;
const Paths_1 = require("../../Paths");
const Utils_1 = require("../../Utils");
const ProfileRequestUtils_1 = require("./utils/ProfileRequestUtils");
class ScheduleRequests {
    constructor(session, profileId) {
        this.session = session;
        this.profileId = profileId;
    }
    create(schedule) {
        return __awaiter(this, void 0, void 0, function* () {
            const scheduleRequest = {
                method: Paths_1.Methods.POST,
                body: Object.assign({}, schedule),
            };
            return this.genericScheduleRequest(scheduleRequest);
        });
    }
    remove(scheduleUUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const scheduleRequest = {
                method: Paths_1.Methods.DELETE,
                body: {
                    uuid: scheduleUUID,
                },
            };
            return this.genericScheduleRequest(scheduleRequest);
        });
    }
    update(uuid, request) {
        return __awaiter(this, void 0, void 0, function* () {
            const scheduleRequest = {
                method: Paths_1.Methods.PUT,
                body: Object.assign(Object.assign({}, request), { uuid }),
            };
            return this.genericScheduleRequest(scheduleRequest);
        });
    }
    get(scheduleUUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
                body: {
                    uuid: scheduleUUID,
                },
            };
            return this.genericScheduleRequest(options);
        });
    }
    genericScheduleRequest(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = (0, ProfileRequestUtils_1.getEndpoint)(this.session, options, this.profileId, Paths_1.Constants.SCHEDULES);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
}
exports.ScheduleRequests = ScheduleRequests;
//# sourceMappingURL=ScheduleRequests.js.map